import React, { useEffect, useState } from 'react';
import '../../css/billstyle.css'
import {useDispatch, useSelector } from 'react-redux';
import { fatchUserAPI,fatchPhotoAPI,fatchSignAPI,fatchLrIDAPI,fatchTearmsAPI,fatchBankAPI} from '../../redux/actionCreation';import { parseISO, format } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import { Link, useNavigate, useParams } from 'react-router-dom';
import 'react-quill/dist/quill.snow.css'; // Import the styles
import DOMPurify from 'dompurify';
import { Helmet } from 'react-helmet';
import html2pdf from 'html2pdf.js';
import Loader from '../Loader';
import { Row } from 'react-bootstrap';

function LrEditdesign() {
    //view port set
    useEffect(() => {
        // Update the viewport meta tag when ABCComponent mounts
        const metaTag = document.querySelector('meta[name="viewport"]');
        if (metaTag) {
          metaTag.setAttribute('content', 'width=device-width, initial-scale=0.4, maximum-scale=1.0, user-scalable=yes');
        }
    
        // Clean up function to reset the viewport when ABCComponent unmounts
        return () => {
          if (metaTag) {
            metaTag.setAttribute('content', 'width=device-width, initial-scale=1');
          }
        };
      }, []); // Run only once on component mount
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const dispatchFetchPhoto = useDispatch();
    
    const fetchLrIdReducers = useSelector(state => state.fetchLrIdReducers);
    const LrData = fetchLrIdReducers.data;

    const fetchLrReducers = useSelector(state => state.fetchLrReducers);
    const FetchBankReducers = useSelector(state => state.FetchBankReducers);
    const FeatchTearmsReducers = useSelector(state => state.FeatchTearmsReducers);
    const signatures = useSelector((state) => state.fetchReducers);
    const hasSignature = signatures.data.some(signature => signature.signature_data);
    const fetchcompanyLogo = useSelector(state => state.fetchcompanyLogo);
    const fetchUserReducres = useSelector(state => state.fetchUserReducres);
    const email = fetchUserReducres.data ? fetchUserReducres.data.email : null;
    const company_name = fetchUserReducres.data ? fetchUserReducres.data.company_name : null;
    const phone_number = fetchUserReducres.data ? fetchUserReducres.data.phone_number : null;
    const phone_number_2 = fetchUserReducres.data ? fetchUserReducres.data.phone_number_2 : null;
    const company_website = fetchUserReducres.data ? fetchUserReducres.data.company_website : null;
    const company_GST = fetchUserReducres.data ? fetchUserReducres.data.company_GST : null;
    const company_add = fetchUserReducres.data ? fetchUserReducres.data.company_add : null;
    const navigate = useNavigate();
    useEffect(()=>{
        if(!localStorage.getItem('tokan')){
            navigate('/login');
        }
    }, []);

    useEffect(() => {
        const fetchDataUser = async () => {
            try {
                const res = await dispatch(fatchUserAPI());
            } catch (error) {
                console.error('Error fetching Company Details data:', error);
            }
        };
        fetchDataUser();
    }, []);

    const { id } = useParams();
    useEffect(() => {
        const fetchDataQute = async () => {
        try {
            const res = await dispatch(fatchLrIDAPI(id));
            console.log('API Response:', res);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        };
        fetchDataQute(); // Call the async function
    }, [id]); // Include 'id' in the dependency array

    useEffect(() => {
        const fetchDataSign = async () => {
            try {
                const res = await dispatch(fatchSignAPI());
                // Process the result if needed
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchDataSign(); // Call the async function
    }, []);

    useEffect(() => {
        const fetchPhoto = async () => {
            try {
              const res = await dispatchFetchPhoto(fatchPhotoAPI());
                // Process the result if needed
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchPhoto(); // Call the async function
    }, []);

    useEffect(() => {
        const fetchDataTearms = async () => {
            try {
                const res = await dispatch(fatchTearmsAPI());
                // Process the result if needed
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchDataTearms(); // Call the async function
    }, []);

    useEffect(() => {
        const fetchBank = async () => {
            try {
                const res = await dispatch(fatchBankAPI());
                // Process the result if needed
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchBank(); // Call the async function
    }, []);
    
    const imageUrl = `https://app.packersbilling.in/api/${fetchcompanyLogo.data?.[0]?.path}`;
    const [base64URL, setBase64URL] = useState('');
    useEffect(() => {
        const fetchImage2 = async () => {
        try {
            const response = await fetch(imageUrl);
            if (!response.ok) {
            throw new Error(`Failed to fetch image. Status: ${response.status}`);
            }
            const blob = await response.blob();
            const reader = new FileReader();
            reader.onloadend = () => {
            const base64 = reader.result;
            setBase64URL(base64);
            };
            reader.readAsDataURL(blob);
        } catch (error) {
            console.error('Error fetching or converting the image:', error);
        }
        };
  
        fetchImage2();
    }, [imageUrl]);
  
    const formatDate = (dateStr) => {
    if (!dateStr || dateStr === "") return "--";
    
    const date = new Date(dateStr);
    
    // Agar invalid date string aayi toh error se bachne ke liye
    if (isNaN(date.getTime())) return "--";

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months 0-11 hote hain
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
};


// Is calculation ko render function ke andar ya return se pehle rakhein
// Function jo 0 ko "--" mein badal dega
const displayVal = (val) => {
    return (val == 0 || val == null || val == undefined || val == "") ? "--" : val;
};

// Calculations
const subtotalValue = 
    Number(LrData.total_basic_f || 0) + 
    Number(LrData.loading_charge || 0) + 
    Number(LrData.unloading_charge || 0) + 
    Number(LrData.st_charge || 0) + 
    Number(LrData.other_charge || 0) + 
    Number(LrData.lrcn_charge || 0);

const gstAmountValue = (subtotalValue * Number(LrData.gst_per || 0)) / 100;
const grandTotalValue = Math.round(subtotalValue + gstAmountValue);

const toWords = (num) => {
    if (num === 0 || !num) return "";
    const a = ['', 'One ', 'Two ', 'Three ', 'Four ', 'Five ', 'Six ', 'Seven ', 'Eight ', 'Nine ', 'Ten ', 'Eleven ', 'Twelve ', 'Thirteen ', 'Fourteen ', 'Fifteen ', 'Sixteen ', 'Seventeen ', 'Eighteen ', 'Nineteen '];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const makeWords = (n) => {
        if (n < 20) return a[n];
        if (n < 100) return b[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + a[n % 10] : "");
        if (n < 1000) return makeWords(Math.floor(n / 100)) + " Hundred " + (n % 100 !== 0 ? makeWords(n % 100) : "");
        if (n < 100000) return makeWords(Math.floor(n / 1000)) + " Thousand " + (n % 1000 !== 0 ? makeWords(n % 1000) : "");
        if (n < 10000000) return makeWords(Math.floor(n / 100000)) + " Lakh " + (n % 100000 !== 0 ? makeWords(n % 100000) : "");
        return makeWords(Math.floor(n / 10000000)) + " Crore " + (n % 10000000 !== 0 ? makeWords(n % 10000000) : "");
    };

    return makeWords(Math.round(num)) + "Only";
};


const handleDownloadPdf = async (elementId, fileName) => {
  const element = document.getElementById(elementId);

  if (!element) {
    alert("LR Content not found!");
    return;
  }

  // Step 1: Force scroll to top (Blank space avoid karne ke liye)
  window.scrollTo(0, 0);

  const options = {
    margin: [5, 5, 5, 5],
    filename: `${fileName}.pdf`,
    image: { type: 'jpeg', quality: 0.95 }, // Size optimize karne ke liye 0.95
    html2canvas: {
      scale: 2,
      useCORS: true,
      scrollY: 0,
      scrollX: 0,
      windowHeight: element.scrollHeight,
      logging: false,
    },
    jsPDF: { 
      unit: 'mm', 
      format: 'a4', 
      orientation: 'portrait',
      compress: true // File size chota rakhne ke liye
    },
    pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
  };

  // Step 2: Delay for scroll stability
  setTimeout(async () => {
    try {
      // PDF generate karein (Blob format mein)
      const pdfBlob = await html2pdf().set(options).from(element).output('blob');
      const pdfUrl = URL.createObjectURL(pdfBlob);
      
      const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

      if (isMobile) {
        // --- MOBILE LOGIC ---
        // User ko option dena ki sirf download karna hai ya share
        const userAction = window.confirm(`Do you want to SHARE "${fileName}"? \n(Click 'Cancel' to just DOWNLOAD)`);

        if (userAction && navigator.share) {
          // SHARE logic
          const file = new File([pdfBlob], `${fileName}.pdf`, { type: 'application/pdf' });
          await navigator.share({
            files: [file],
            title: fileName,
            text: `Please check the attached LR: ${fileName}`,
          });
        } else {
          // DOWNLOAD logic
          const link = document.createElement('a');
          link.href = pdfUrl;
          link.download = `${fileName}.pdf`;
          link.click();
        }
      } else {
        // --- PC LOGIC ---
        // 1. Automatic Download
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = `${fileName}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // 2. Open in New Tab (Search nahi karna padega)
        window.open(pdfUrl, '_blank');
      }
    } catch (error) {
      console.error("LR PDF Error:", error);
      alert("Error generating LR PDF");
    }
  }, 100);
};
  return (
    <>
    {loading && <div className='text-center mt-4'>
        <Loader />
    </div>}
    {!loading && (
    <Row>
        {LrData && typeof LrData === 'object' && (
        <div className="container-fluid invoice-container"> 
            <div id=''>
                <header>
                    <div className="row align-items-center gy-3 header_sec_b">
                        <div className="col-sm-3 text-center text-sm-start">
                            <div>
                                {base64URL ? (
                                    <div>
                                    <img src={base64URL} alt="logo" className='logo'/>
                                    </div>
                                ) : (
                                    <Link to="/update-company" className='btn btn-primary'>Add Logo</Link>
                                )}
                            </div>
                        </div>
                        <div className="col-sm-9 text-center text-sm-end">
                            <h4 className="mb-1">{company_name}</h4>
                            <p className="mb-1"><i className='fa fa-map-marker-alt'></i> {company_add}</p>
                            <div className='d-flex align-items-center justify-content-end mb-1'>
                                <p className="mb-0 mx-2 email"><i className='fa fa-envelope'></i> {email}</p>
                                <p className="mb-0"><i className='fa fa-phone'></i> +91 {phone_number} {phone_number_2 && ( // Check if phone_number_2 exists
                                    <span>, {phone_number_2}</span>
                                )}</p>
                            </div>
                            <div className='d-flex align-items-center justify-content-end'>
                                {company_GST && ( // Check if company_GST exists
                                    <p className="mb-0 mx-2"><i className='fa fa-file'></i> GSTIN : {company_GST}</p>
                                )}
                                {company_website && ( // Check if company_GST exists
                                    <p className="mb-0 text-lowercase"><i className='fa fa-globe-americas'></i> {company_website}</p>
                                )}
                            
                            </div>
                        </div>
                    </div>
                </header>
                <main>
                    <div className="row gy-3">
                        <div className="col-md-12 mt-2 mb-0 p-0">
                            {/* <strong>Quotation Number:</strong> <span>{item.quotation_number}</span>  */}
                             <table className="table table-bordered text-1 my_table mb-0">
                                <tbody>
                                    <tr className="bg-light">
                                        <th colspan="6" className='pt-2 pb-2 pr-1 pl-2 text-center text-white notice-cell'><strong>Notice</strong></th>
                                        <th colspan="6" className='pt-2 pb-2 pr-1 pl-2 text-center text-white notice-cell'><strong>
                                            {LrData.risk_type}
                                        </strong></th>
                                        <th colspan="6" className='pt-2 pb-2 pr-1 pl-2 text-center text-white notice-cell'><strong>LR Note</strong></th>
                                    </tr>

                                    <tr>
                                    {/* NOTICE – BIG WIDTH */}
                                        <td colSpan={6} className="notice-cell">
                                            <div className="notice-box">
                                            The consignment by the lorry receipt shall be stored at the destination
                                            under the control of the transport operator and shall be delivered to
                                            the order of the consignee whose name is mentioned in the lorry receipt.
                                            It will under no circumstances be delivered to anyone without written
                                            authorization from the consignee on its order.
                                            </div>
                                        </td>

                                        {/* AT OWNER'S RISK – MEDIUM */}
                                        <td colSpan={6} className="p-0 notice-cell">
                                            <table className="table table-bordered m-0 w-100" style={{ tableLayout: "fixed" }}>
                                            <tbody>
                                                <tr>
                                                <td colSpan={4} className="text-center fw-bold">
                                                    Material {LrData.material_Insu}
                                                </td>
                                                </tr>
                                                <tr>
                                                <td colSpan={2}>Insurance Company</td>
                                                <td colSpan={2}> {LrData.insu_company}</td>
                                                </tr>
                                                <tr>
                                                <td colSpan={2}>Policy Number</td>
                                                <td colSpan={2}>
                                                     {LrData.policy_num}
                                                </td>
                                                </tr>
                                                <tr>
                                                <td colSpan={2}>Insurance Date</td>
                                                <td colSpan={2}><b>{formatDate(LrData.insu_date)}</b></td>
                                                </tr>
                                                <tr>
                                                <td colSpan={2}>Insured Amount</td>
                                                <td colSpan={2}>{displayVal(LrData.insu_amount)}</td>
                                                </tr>
                                            </tbody>
                                            </table>
                                        </td>

                                        {/* LR / CONSIGNMENT NOTE */}
                                        <td colSpan={6} className="p-0 notice-cell">
                                            <table className="table table-bordered m-0 w-100" style={{ tableLayout: "fixed" }}>
                                            <tbody>
                                                <tr>
                                                <td colSpan={4}><b>LR No.</b> &nbsp; {LrData.lr_number}</td>
                                                </tr>
                                                <tr>
                                                <td colSpan={2}>LR Data</td>
                                                <td colSpan={2}><b>{formatDate(LrData.lr_date)}</b></td>
                                                </tr>
                                                
                                                <tr>
                                                <td colSpan={2}>Move From</td>
                                                <td colSpan={2}><b>{LrData.consignor_city}</b></td>
                                                </tr>
                                                <tr>
                                                <td colSpan={2}>Move To</td>
                                                <td colSpan={2}><b>{LrData.consignee_city}</b></td>
                                                </tr>
                                                <tr>
                                                <td colSpan={2}>Vehicle No.</td>
                                                <td colSpan={2}><b>{LrData.truck_number}</b></td>
                                                </tr>
                                                <tr>
                                                <td colSpan={4}
                                                    className="text-center fw-bold text-uppercase bg-light-4"
                                                    style={{ background: "", color: "#000" }}>
                                                    Consignor Copy
                                                </td>
                                                </tr>
                                            </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="col-md-12 mb-0 p-0 mt-0">
                                <table className="table table-bordered text-1 my_table mb-0">
                                    <tbody>
                                        <tr className="bg-light">
                                            <th colspan="18" className='pt-2 pb-2 pr-1 pl-4 text-center text-white notice-cell'>
                                                <strong>Driver Details </strong>
                                            </th>
                                        </tr>

                                        <tr className="">
                                            <td colspan="6" className='pt-2 pb-2 pr-1 pl-2 text-center notice-cell'>
                                                <strong>Driver Name : </strong> {LrData.driver_name}
                                            </td>
                                            <td colspan="6" className='pt-2 pb-2 pr-1 pl-2 text-center notice-cell'>
                                                <strong>Driver Contact No. : </strong> {LrData.driver_phone}
                                            </td>
                                            <td colspan="6" className='pt-2 pb-2 pr-1 pl-2 text-center notice-cell'>
                                                <strong>Driver Licence No. : </strong> {LrData.driver_licence}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                        </div>
                        
                        <div className="col-md-12 mb-0 p-0 mt-0">
                            {/* <strong>Quotation Number:</strong> <span>{item.quotation_number}</span>  */}
                             <table className="table table-bordered text-1 my_table mb-0">
                                <tbody>
                                    <tr className="bg-light">
                                        <th colspan="6" className='pt-2 pb-2 pr-1 pl-2 text-center text-white notice-cell'><strong>Consignor Details</strong></th>
                                        <th colspan="6" className='pt-2 pb-2 pr-1 pl-2 text-center text-white notice-cell'><strong>Consignee Details</strong></th>
                                        <th colspan="6" className='pt-2 pb-2 pr-1 pl-2 text-center text-white notice-cell'><strong>Freight</strong></th>
                                    </tr>

                                    <tr>
                                    {/* NOTICE – BIG WIDTH */}
                                        <td colSpan={6} className="notice-cell">
                                            <div className="">
                                              <p>Name: <b>{LrData.consignor_name}</b></p>
                                              <div className='d-flex gap-2'>
                                                <p>Mob: <b>{LrData.consignor_phone}</b></p>
                                                <p>GST No: <b>{LrData.consignor_gst}</b></p>
                                              </div>
                                              <p className='mb-0'>Address: <b>{LrData.consignor_add}</b></p>
                                            </div>
                                        </td>

                                         <td colSpan={6} className="notice-cell">
                                            <div className="">
                                              <p>Name: <b>{LrData.consignee_name}</b></p>
                                              <div className='d-flex gap-2'>
                                                <p>Mob: <b>{LrData.consignee_phone}</b></p>
                                                <p>GST No: <b>{LrData.consignee_gst}</b></p>
                                              </div>
                                              <p className='mb-0'>Address: <b>{LrData.consignee_add}</b></p>
                                            </div>
                                        </td>
                                        
                                        {/* LR / CONSIGNMENT NOTE */}
                                        <td colSpan={6} className="p-0 notice-cell">
                                            <table className="table table-bordered m-0 w-100" style={{ tableLayout: "fixed" }}>
                                            <tbody>
                                                <tr>
                                                    <td colSpan={2}>Paid</td>
                                                    <td colSpan={2}>
                                                    <b>{displayVal(LrData.f_paid)}</b>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={2}>To Pay</td>
                                                    <td colSpan={2}><b>{displayVal(LrData.f_to_pay)}</b></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={2}>To Be Billed</td>
                                                    <td colSpan={2}><b>{displayVal(LrData.f_to_bill)}</b></td>
                                                </tr>
                                                
                                                <tr>
                                                    <td colSpan={2}>GST Paid By</td>
                                                    <td colSpan={2}><b>{LrData.gst_paid_by}</b></td>
                                                </tr>
                                            </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="col-md-8 mb-0 p-0 mt-0">
                            <table className="table table-bordered text-1 my_table mb-0" style={{ height: '100%' }}>
                                <thead>
                                    <tr className="bg-light text-center text-white notice-cell">
                                        <th colSpan="2" style={{ width: '60%' }}>Packages and Goods Description</th>
                                        <th colSpan="2" style={{ width: '40%' }}>Weight</th>
                                    </tr>
                                    <tr className="text-center">
                                        {/* <th style={{ border: 'none' }}></th> */}
                                        <td colSpan={2}><p className="mb-0 text-start">No. Of Packages: <b>{LrData.no_package}</b></p></td>
                                        <th>Actual</th>
                                        <th>Charged</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td colSpan="2" style={{ verticalAlign: 'top', height: '100px', border: '1px solid #000'}}>
                                            <p className="mb-1">{LrData.pack_condition}, {LrData.pack_desc}</p>
                                            <p className="mb-0"><strong>Remark :-</strong>{LrData.remark}</p>
                                        </td>
                                        <td className="text-center" style={{ verticalAlign: 'middle' }}>
                                            <b>
                                                {displayVal(LrData.ac_weight)}
                                            </b> <b>
                                                {displayVal(LrData.ac_weight_type)}
                                            </b>
                                        </td>
                                        <td className="text-center" style={{ verticalAlign: 'middle' }}>
                                            <b>
                                                {displayVal(LrData.char_weight)}
                                            </b> <b>
                                                {LrData.charg_weight_type}
                                            </b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="4" className='pb-0'>
                                            <p className='mb-0'><b>Schedule of demurrage charge :-</b></p>
                                            <p className='mb-0'>Demurrage charge after More Than {LrData.demurrage_time}, @ {LrData.demurrage_charge} Rupees {LrData.demurrage_type} + handling & local transportation charges.</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="4" className='pb-0'>
                                            <strong>Total Rupees in Words :-</strong> <span><b>
                                                {LrData.f_paid && LrData.f_paid != 0 
                                                    ? toWords(Number(LrData.f_paid)) 
                                                    : "--"}
                                            </b></span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="col-md-4 mb-0 p-0 mt-0">
                            <table className="table table-bordered text-1 my_table mb-0">
                                <thead>
                                    <tr className="bg-light text-center text-white notice-cell">
                                        <th colSpan="2">FREIGHT DETAILS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Basic Freight</td>
                                        <td className="text-center">{displayVal(LrData.total_basic_f)}</td>
                                    </tr>
                                    <tr>
                                        <td>Loading Charge</td>
                                        <td className="text-center">{displayVal(LrData.loading_charge)}</td>
                                    </tr>
                                    <tr>
                                        <td>Unloading Charge</td>
                                        <td className="text-center">{displayVal(LrData.unloading_charge)}</td>
                                    </tr>
                                    <tr>
                                        <td>S.T. Charge</td>
                                        <td className="text-center">{displayVal(LrData.st_charge)}</td>
                                    </tr>
                                    <tr>
                                        <td>Other Charge</td>
                                        <td className="text-center">{displayVal(LrData.other_charge)}</td>
                                    </tr>
                                    <tr>
                                        <td>LR/CN Charge</td>
                                        <td className="text-center">{displayVal(LrData.lrcn_charge)}</td>
                                    </tr>

                                    {/* Subtotal Section */}
                                    <tr className="font-weight-bold">
                                        <td>Subtotal</td>
                                        <td className="text-center">{displayVal(subtotalValue)}</td>
                                    </tr>

                                    {/* GST Section */}
                                    <tr>
                                        <td>Gst ({LrData.gst_per || 0}%)</td>
                                        <td className="text-center">{displayVal(gstAmountValue.toFixed(2))}</td>
                                    </tr>

                                    {/* Total Section (Round Figure) */}
                                    <tr className="bg-light font-weight-bold">
                                        <td>Total</td>
                                        <td className="text-center text-white">
                                            <b>{displayVal(grandTotalValue)}</b>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="col-md-8 mb-0 p-0 mt-0">
                            <table className="table table-bordered text-1 my_table mb-0" style={{ height: '100%' }}>
                                <tbody>
                                    <tr>
                                        <td colSpan="4" className=''>
                                            <strong>
                                                I/WE CAREFULLY CHECKED AND VERIFIED THE CONTENT FILLED IN THIS CONSIGNMENT NOTE AND AGREE TO THE TERMS AND CONDITIONS PRINTED OVERLEAF ESPECIALLY THE CLAUSE OF JURISDICTION ALL CHARGES AS PER AGREEMENT
                                            </strong>
                                        </td>
                                    </tr>

                                    {/* <tr>
                                        <td colSpan="4" className=''>
                                            <div>
                                                Consignor Signature
                                            </div>
                                        </td>
                                    </tr> */}
                                </tbody>
                            </table>                    
                        </div>

                         <div className="col-md-4 mb-0 p-0 mt-0">
                            <table className="table table-bordered text-1 my_table mb-0" style={{ height: '100%' }}>
                                <tbody>
                                    <tr>
                                        <td colSpan="4" className=''>
                                            <h4 className="text-3 mt-4 stemp"><strong>For :</strong> {company_name}</h4>
                                    {[...signatures.data].map((signature, index) => (
                                        <img key={index} src={signature.signature_data} alt={`Signature ${index + 1}`} className='sign-size' />
                                    ))}
                                    {!hasSignature && (
                                        <Link to="/update-company" className='d-print-none btn btn-primary'>
                                            Add Sign
                                        </Link>
                                    )}
                                    <p className='mb-0 stemp'>Authorized Signature</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>                    
                        </div>
                    </div>
                </main>
            </div>
   
        </div>
        )}
    </Row>
    )}
       
    </>
  )
}
export default LrEditdesign

